import { Helmet } from "react-helmet-async";

const SITE_NAME = "Carix";
// REACT_APP_SITE_URL permet de pointer les canonical/OG/JSON-LD vers le bon
// domaine sur un build staging (ex: drivora.ma) sans toucher au code —
// à défaut, on suppose qu'on est sur le vrai site de production.
const SITE_URL = process.env.REACT_APP_SITE_URL || "https://www.carix.ma";
// Coupe l'indexation de TOUT le site (staging/test) sans avoir à y penser
// page par page — chaque <SEO> peut encore forcer noindex=true localement,
// mais aucune page ne doit jamais forcer noindex=false pour contourner ceci.
const ALLOW_INDEXING = process.env.REACT_APP_ALLOW_INDEXING !== "false";
const DEFAULT_DESCRIPTION = "Carix - Achetez et vendez des voitures, motos et véhicules utilitaires d'occasion au Maroc. Des milliers d'annonces vérifiées.";
const DEFAULT_IMAGE = `${SITE_URL}/logo192.png`;

// Balises title/description/Open Graph pour une page donnée, plus un bloc
// JSON-LD optionnel (schema.org) pour les résultats enrichis Google.
// path doit commencer par "/" (ex: "/cars-details/42").
export default function SEO({
  title,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  path = "",
  type = "website",
  jsonLd = null,
  noindex = false,
}) {
  const shouldNoIndex = noindex || !ALLOW_INDEXING;
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Voitures, motos et utilitaires d'occasion au Maroc`;
  const canonical = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {shouldNoIndex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content="fr_MA" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
